import _classCallCheck from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/home/runner/work/digital-chamada/digital-chamada/frontend/chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import Vue from "vue";
var AxiosUtils = /*#__PURE__*/function () {
  function AxiosUtils() {
    _classCallCheck(this, AxiosUtils);
  }
  _createClass(AxiosUtils, [{
    key: "get",
    value: function get() {
      var _Vue$prototype$$axios;
      return (_Vue$prototype$$axios = Vue.prototype.$axios).get.apply(_Vue$prototype$$axios, arguments);
    }
  }, {
    key: "post",
    value: function post() {
      var _Vue$prototype$$axios2;
      return (_Vue$prototype$$axios2 = Vue.prototype.$axios).post.apply(_Vue$prototype$$axios2, arguments);
    }
  }, {
    key: "delete",
    value: function _delete() {
      var _Vue$prototype$$axios3;
      return (_Vue$prototype$$axios3 = Vue.prototype.$axios).delete.apply(_Vue$prototype$$axios3, arguments);
    }
  }, {
    key: "put",
    value: function put() {
      var _Vue$prototype$$axios4;
      return (_Vue$prototype$$axios4 = Vue.prototype.$axios).put.apply(_Vue$prototype$$axios4, arguments);
    }
  }, {
    key: "getBaseUrl",
    value: function getBaseUrl() {
      return Vue.prototype.$axios.defaults.baseURL;
    }
  }]);
  return AxiosUtils;
}();
export default AxiosUtils;